<template>
  <div class="outer-container">
    <div class="line" />
    <div class="rounded-box">
      <FriedH4 class="text">{{ t('cr_or') }}</FriedH4>
    </div>
    <div class="line" />
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
<style lang="scss" scoped>
.outer-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;

  .line {
    height: 1px;
    background: var(--gray-92);
    width: 100%;
  }

  .rounded-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--radius-large);
    border: 1px solid var(--gray-92);
    padding: 0 var(--spacing-100);
    width: 52px;

    .text {
      color: var(--text-gray);
    }
  }
}
</style>
